import {
  trigger,
  state,
  transition,
  style,
  animate,
  query,
  stagger,
  keyframes
} from "@angular/animations";

export const fade = trigger("fade", [
  transition("void => *", [
    style({ opacity: 0 }),
    animate(2000, style({ opacity: 1 }))
  ])
]);

export const flyIn = trigger("flyIn", [
  state("in", style({ transform: "translateX(0)" })),
  transition("void => *", [
    style({ transform: "translateX(-100%)" }),
    animate(100)
  ]),
  transition("* => void", [
    animate(100, style({ transform: "translateX(100%)" }))
  ])
]);

export const listAnimation = trigger("listAnimation", [
  transition("* => *", [
    query(":enter", style({ opacity: 0 }), { optional: true }),

    query(
      ":enter",
      stagger("300ms", [
        animate(
          "1s ease-in",
          keyframes([
            style({ opacity: 0, transform: "translateY(-75%)", offset: 0 }),
            style({ opacity: 0.5, transform: "translateY(35px)", offset: 0.3 }),
            style({ opacity: 1, transform: "translateY(0)", offset: 1.0 })
          ])
        )
      ]),
      { optional: true }
    )
  ])
]);

export const explainerAnim = trigger("explainerAnim", [
  transition("* => *", [
    query(".anime", style({ opacity: 0, transform: "translateX(-40px)" })),

    query(
      ".anime",
      stagger("500ms", [
        animate(
          "800ms 1.2s ease-out",
          style({ opacity: 1, transform: "translateX(0)" })
        )
      ])
    ),

    query(".anime", [animate(1000, style("*"))])
  ])
]);



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/core/animations.ts